import { ModBox } from '@jfs/ui-new'
import { BulkBeneficiaryFileUpload } from '../BulkBeneficiaryFileUpload'

const BulkBeneficiary = ({
  fileUploadProgress,
  resetState,
  fileName,
  mid,
  onFileSelected,
  downloadSampleFile,
  file,
  onHandleAddBeneficiaries,
}: any) => {
  return (
    <ModBox w={'100%'} h={342} alignItems={'center'} justifyContent={'center'}>
      <BulkBeneficiaryFileUpload
        progress={fileUploadProgress}
        navToHistory={() => resetState(true)}
        name={fileName}
        onHandleCancelChangeFile={() => resetState(false)}
        mid={mid}
        tabIndex={0}
        onFileSelected={onFileSelected}
        handleDownloadSampFile={downloadSampleFile}
        file={file}
        resetState={resetState}
        onHandleAddBeneficiaries={onHandleAddBeneficiaries}
      />
    </ModBox>
  )
}

export { BulkBeneficiary }
